export const sin = (angle: number): number => Math.sin((angle * Math.PI) / 180)
